export const AUTH = "AUTH";
export const CHECK_PASSWORD = "CHECK_PASSWORD";
export const PASSWORD_CHANGE = "PASSWORD_CHANGE";

